import {
  BusinessManagementDocument,
  BusinessesDocument,
  BusinessesManagementDocument,
  MeDocument,
  PrimaryBusinessUsageDocument,
  ProjectAnalyticsViewsDocument,
  ProjectBranchDocument,
  ProjectDocument,
  PullRequestDocument,
  VercelEdgeConfigStoresDocument,
} from "../../generated/graphql";

export const businessManagementRefetchQueries = [
  BusinessesDocument,
  BusinessManagementDocument,
  BusinessesManagementDocument,
  PrimaryBusinessUsageDocument,
];

export const switchBusinessRefetchQueries = [
  ...businessManagementRefetchQueries,
  VercelEdgeConfigStoresDocument,
  MeDocument,
];

export const newCommitRefetchQueries = [
  ProjectDocument,
  ProjectBranchDocument,
  PullRequestDocument,
];

export const refetchAnalyticsViewsQueries = [
  ProjectDocument,
  ProjectAnalyticsViewsDocument,
];
